import { slideDown, slideUp } from './slideUpDown';

function hiddenScrolled(isShow: boolean = true) {
	document.querySelectorAll('.hidden-scrolled').forEach((element: HTMLElement) => {
		// element.style.display = isShow ? '' : 'none';

		isShow ? slideDown(element) : slideUp(element);
	});
}

window.addEventListener('scroll', function () {
	hiddenScrolled(!(window.scrollY > 0));
});

hiddenScrolled(!(window.scrollY > 0));
